import { endpointConstants } from "../constants";
import { get, post } from "../../utils";
import config from "../../utils/globalConfig";
import prepareCatalogueFilters from "../../utils/prepareCatalogueFilters";

export const yodaCatalogueService = {
  getOne,
  getOneSwap,
  getAll,
  getAllSwap,
  getOneCatalog,
  getOneCatalogSwap,
  sendLog,
};

function getOne(customerId, productId, seasonId) {
  let endpoint = endpointConstants.YODACATALOGUE.GET_ONE.replace(
    ":customerId",
    customerId,
  )
    .replace(":productId", productId)
    .replace(":seasonId", seasonId);
  return get(endpoint, {});
}

function getOneSwap(customerId, productId, seasonId) {
  let endpoint = endpointConstants.YODACATALOGUE.GET_ONE_SWAP.replace(
    ":customerId",
    customerId,
  )
    .replace(":productId", productId)
    .replace(":seasonId", seasonId);
  return get(endpoint, {});
}

function getOneCatalog(catalogId) {
  let endpoint = endpointConstants.YODACATALOGUE.GET_ONE_CATALOG.replace(
    ":catalogId",
    catalogId,
  );
  return get(endpoint);
}

function getOneCatalogSwap(catalogId) {
  let endpoint = endpointConstants.YODACATALOGUE.GET_ONE_CATALOG.replace(
    ":catalogId",
    catalogId,
  );
  return get(endpoint);
}

function getAll({
  searchText,
  seasonId,
  lineId,
  customerId,
  page,
  pageSize,
  collectionIds,
  categoryIds,
  subcategoryIds,
  colorIds,
  sizeIds,
  continuousIds,
  fittingIds,
  closureIds,
  hoodIds,
  paddingIds,
  pocketsIds,
  reversibleIds,
  sleevesIds,
}) {
  let filters = prepareCatalogueFilters({
    collectionIds,
    categoryIds,
    subcategoryIds,
    colorIds,
    sizeIds,
    continuousIds,
    fittingIds,
    closureIds,
    hoodIds,
    paddingIds,
    pocketsIds,
    reversibleIds,
    sleevesIds,
  });

  let endpoint = endpointConstants.YODACATALOGUE.GET_ALL.replace(
    ":seasonId",
    seasonId,
  )
    .replace(":searchText", searchText || "")
    .replace(":lineId", lineId)
    .replace(":customerId", customerId)
    .replace(":page", page ? page : 1)
    .replace(":pageSize", pageSize ? pageSize : config.PAGE_SIZE);
  if (filters.length > 0) {
    endpoint += "&Filters=" + encodeURIComponent(JSON.stringify(filters));
  } else {
    endpoint += "&Filters";
  }
  return get(endpoint);
}

function getAllSwap({
  searchText,
  seasonId,
  lineId,
  customerId,
  collectionIds,
  categoryIds,
  subcategoryIds,
  colorIds,
  sizeIds,
  page,
  pageSize,
  continuousIds,
  fittingIds,
  closureIds,
  hoodIds,
  paddingIds,
  pocketsIds,
  reversibleIds,
  sleevesIds,
}) {
  let filters = prepareCatalogueFilters({
    collectionIds,
    categoryIds,
    subcategoryIds,
    colorIds,
    sizeIds,
    continuousIds,
    fittingIds,
    closureIds,
    hoodIds,
    paddingIds,
    pocketsIds,
    reversibleIds,
    sleevesIds,
  });

  let endpoint = endpointConstants.YODACATALOGUE.GET_ALL_SWAP.replace(
    ":seasonId",
    seasonId,
  )
    .replace(":searchText", searchText || "")
    .replace(":lineId", lineId)
    .replace(":customerId", customerId)
    .replace(":page", page ? page : 1)
    .replace(":pageSize", pageSize ? pageSize : config.PAGE_SIZE);
  if (filters.length > 0) {
    endpoint += "&Filters=" + encodeURIComponent(JSON.stringify(filters));
  } else {
    endpoint += "&Filters";
  }
  return get(endpoint);
}

function sendLog(payload) {
  return post(endpointConstants.YODACATALOGUE.SEND_LOG, payload);
}
